import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TaxFormComponent } from './tax-form.component';

import {InputMaskModule} from 'primeng/inputmask';

import { MaskitoModule } from '@maskito/angular';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    InputMaskModule,
    MaskitoModule
  ],
  declarations: [TaxFormComponent],
  exports: [TaxFormComponent],
})
export class TaxFormModule {}
